export const AddEventsHoverIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
    >
      <path
        d="M2.38389 4.2852C3.11675 3.75275 4.00029 3.47698 5.20482 3.33416V4.33735C5.20482 5.29553 5.98158 6.07229 6.93976 6.07229C7.89794 6.07229 8.6747 5.29553 8.6747 4.33735V3.18397C9.21148 3.18072 9.78831 3.18072 10.4096 3.18072C11.031 3.18072 11.6078 3.18072 12.1446 3.18397V4.33735C12.1446 5.29553 12.9213 6.07229 13.8795 6.07229C14.8377 6.07229 15.6145 5.29553 15.6145 4.33735V3.33416C16.819 3.47698 17.7025 3.75275 18.4354 4.2852C18.9263 4.6419 19.3581 5.07366 19.7148 5.56462C20.3675 6.46304 20.6345 7.5879 20.7437 9.25301H0.0755695C0.184764 7.5879 0.451739 6.46304 1.10448 5.56462C1.46118 5.07366 1.89294 4.6419 2.38389 4.2852Z"
        fill="#245cea"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.0123736 10.9877C0 11.758 0 12.6199 0 13.5904C0 17.9274 0 20.0959 1.10448 21.6161C1.46118 22.1071 1.89294 22.5388 2.38389 22.8955C3.90408 24 6.0726 24 10.4096 24C11.38 24 12.2418 24 13.012 23.9876L13.012 23.9065C13.012 22.9211 13.0119 22.3208 13.0939 21.803C13.5447 18.9572 15.7765 16.7254 18.6223 16.2747C19.1401 16.1926 19.7403 16.1927 20.7258 16.1928L20.8069 16.1928C20.8193 15.4225 20.8193 14.5607 20.8193 13.5904C20.8193 12.6199 20.8193 11.758 20.8069 10.9877L20.7857 10.988H0.0333208L0.0123736 10.9877ZM6.93976 13.8795C6.46067 13.8795 6.07229 14.2679 6.07229 14.747C6.07229 15.2261 6.46067 15.6145 6.93976 15.6145H13.8795C14.3586 15.6145 14.747 15.2261 14.747 14.747C14.747 14.2679 14.3586 13.8795 13.8795 13.8795H6.93976Z"
        fill="#245cea"
      />
      <path
        d="M18.4354 22.8955C17.537 23.5483 16.4121 23.8152 14.747 23.9244C14.7471 22.8715 14.751 22.4311 14.8075 22.0744C15.1406 19.971 16.7903 18.3214 18.8937 17.9882C19.2504 17.9317 19.6908 17.9279 20.7437 17.9277C20.6345 19.5928 20.3675 20.7177 19.7148 21.6161C19.3581 22.1071 18.9263 22.5388 18.4354 22.8955Z"
        fill="#245cea"
      />
      <path
        d="M7.80723 0.86747C7.80723 0.388379 7.41885 0 6.93976 0C6.46067 0 6.07229 0.388379 6.07229 0.86747V4.33735C6.07229 4.81644 6.46067 5.20482 6.93976 5.20482C7.41885 5.20482 7.80723 4.81644 7.80723 4.33735V0.86747Z"
        fill="#245cea"
      />
      <path
        d="M14.747 0.86747C14.747 0.388379 14.3586 0 13.8795 0C13.4004 0 13.012 0.388379 13.012 0.86747V4.33735C13.012 4.81644 13.4004 5.20482 13.8795 5.20482C14.3586 5.20482 14.747 4.81644 14.747 4.33735V0.86747Z"
        fill="#245cea"
      />
    </svg>
  );
};
